let domainVal = '/';
let naturalUrlAttrVal = '';

if (window.demoPage) {
    domainVal = 'http://5.23.52.186/';
    naturalUrlAttrVal = '&dev=1';
}

if (window.demoChartPage) {
    naturalUrlAttrVal = '&dev=1';
}

export const domain = domainVal;
export let naturalUrlAttr = naturalUrlAttrVal;


export const moment = require('moment');
export const defaultDateFormat = 'DD.MM.YYYY';
export const defaultDateWithTimeFormat = 'DD.MM.YYYY HH:mm';
export const defaultShortDateWithTimeFormat = 'DD.MM HH:mm';
export const dbDateFormat = 'YYYY-MM-DD';

export function formatDate(date) {
    return moment(date).format(defaultDateFormat);
}

export function formatDateWithTime(date) {
    return moment(date).format(defaultDateWithTimeFormat);
}

export function formatShortDateWithTime(date) {
    return moment(date).format(defaultShortDateWithTimeFormat);
}

export function formatDbDate(date) {
    return moment(date, defaultDateFormat).format(dbDateFormat);
}

export const ordersStructure = {
    IterBuy: {
        name: window.jsTranslations.IterBuy.name,
        desc: window.jsTranslations.IterBuy.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'integer',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    IterSell: {
        name: window.jsTranslations.IterSell.name,
        desc: window.jsTranslations.IterSell.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'integer',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    OrderAlg: {
        name: window.jsTranslations.OrderAlg.name,
        desc: window.jsTranslations.OrderAlg.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'string',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    TargIdx: {
        name: window.jsTranslations.TargIdx.name,
        desc: window.jsTranslations.TargIdx.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'integer',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    amountForOper: {
        name: window.jsTranslations.amountForOper.name,
        desc: window.jsTranslations.amountForOper.desc,
        isNeedCurrency: true,
        isInCustomFields: false,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    orderAmountForOperExec: {
        name: window.jsTranslations.orderAmountForOperExec.name,
        desc: window.jsTranslations.orderAmountForOperExec.desc,
        isNeedCurrency: true,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    side: {
        name: window.jsTranslations.side.name,
        desc: window.jsTranslations.side.desc,
        isNeedCurrency: false,
        isInCustomFields: false,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    orderId: {
        name: window.jsTranslations.orderId.name,
        desc: window.jsTranslations.orderId.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'integer',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    status: {
        name: window.jsTranslations.status.name,
        desc: window.jsTranslations.status.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    pair: {
        name: window.jsTranslations.pair.name,
        desc: window.jsTranslations.pair.desc,
        isNeedCurrency: false,
        isInCustomFields: false,
        isNeedFilter: false,
        isNeedSort: false,
        isNeedGroup: false,
        isDate: false
    },
    timeInForce: {
        name: window.jsTranslations.timeInForce.name,
        desc: window.jsTranslations.timeInForce.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: false,
        isNeedSort: false,
        isNeedGroup: false,
        isDate: false
    },
    type: {
        name: window.jsTranslations.type.name,
        desc: window.jsTranslations.type.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    sdTime: {
        name: window.jsTranslations.sdTime.name,
        desc: window.jsTranslations.sdTime.desc,
        isNeedCurrency: false,
        isInCustomFields: false,
        isNeedFilter: true,
        filterType: 'date',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: true
    },
    fdTime: {
        name: window.jsTranslations.fdTime.name,
        desc: window.jsTranslations.fdTime.desc,
        isNeedCurrency: false,
        isInCustomFields: false,
        isNeedFilter: true,
        filterType: 'date',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: true
    },
    orderPrice: {
        name: window.jsTranslations.orderPrice.name,
        desc: window.jsTranslations.orderPrice.desc,
        isNeedCurrency: false,
        isInCustomFields: false,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    orderOrigAmount: {
        name: window.jsTranslations.orderOrigAmount.name,
        desc: window.jsTranslations.orderOrigAmount.desc,
        isNeedCurrency: true,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    orderAmount: {
        name: window.jsTranslations.orderAmount.name,
        desc: window.jsTranslations.orderAmount.desc,
        isNeedCurrency: true,
        isInCustomFields: false,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    orderExec: {
        name: window.jsTranslations.orderExec.name,
        desc: window.jsTranslations.orderExec.desc,
        isNeedCurrency: true,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    feeResult: {
        name: window.jsTranslations.feeResult.name,
        desc: window.jsTranslations.feeResult.desc,
        isNeedCurrency: true,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    txCNT: {
        name: window.jsTranslations.txCNT.name,
        desc: window.jsTranslations.txCNT.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'integer',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    orderRemains: {
        name: window.jsTranslations.orderRemains.name,
        desc: window.jsTranslations.orderRemains.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'float',
        isNeedSort: true,
        isNeedGroup: false,
        isDate: false
    },
    clientOrderId: {
        name: window.jsTranslations.clientOrderId.name,
        desc: window.jsTranslations.clientOrderId.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: false,
        filterType: 'float',
        isNeedSort: false,
        isNeedGroup: false,
        isDate: false
    },
    isRobotOrder: {
        name: window.jsTranslations.isRobotOrder.name,
        desc: window.jsTranslations.isRobotOrder.desc,
        yes: window.jsTranslations.isRobotOrder.yes,
        no: window.jsTranslations.isRobotOrder.no,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    cycleEnd: {
        name: window.jsTranslations.cycleEnd.name,
        desc: window.jsTranslations.cycleEnd.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    orderIdPaired: {
        name: window.jsTranslations.orderIdPaired.name,
        desc: window.jsTranslations.orderIdPaired.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'integer',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    cycleStage: {
        name: window.jsTranslations.cycleStage.name,
        desc: window.jsTranslations.cycleStage.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    },
    baseCurr: {
        name: window.jsTranslations.baseCurr.name,
        desc: window.jsTranslations.baseCurr.desc,
        isNeedCurrency: false,
        isInCustomFields: true,
        isNeedFilter: true,
        filterType: 'select',
        isNeedSort: true,
        isNeedGroup: true,
        isDate: false
    }
};

export const customFieldsList = {
    orderId: false,
    status: false,
    timeInForce: false,
    type: false,
    orderOrigAmount: false,
    orderAmountForOperExec: false,
    orderExec: false,
    feeResult: false,
    txCNT: false,
    orderRemains: false,
    TargIdx: false,
    OrderAlg: false,
    IterSell: false,
    IterBuy: false,
    fdTime: false,
    sdTime: false,
    clientOrderId:false,
    isRobotOrder:false,
    cycleEnd: false,
    orderIdPaired:false,
    cycleStage:false,
    baseCurr: false,
};

export const translateOptions = {
    from: window.jsTranslations.from,
    to: window.jsTranslations.to,
    selectDefault: window.jsTranslations.selectDefault,
    sortButton: window.jsTranslations.sortButton,
    groupButton: window.jsTranslations.groupButton,
    asc: window.jsTranslations.asc,
    desc: window.jsTranslations.desc,
    notValue: window.jsTranslations.notValue,


    tickerName: window.jsTranslations.tickerName,
    tickerSell: window.jsTranslations.tickerSell,
    tickerBuy: window.jsTranslations.tickerBuy,
    tickerMax: window.jsTranslations.tickerMax,
    tickerMin: window.jsTranslations.tickerMin,
    tickerAv: window.jsTranslations.tickerAv,
    tickerInOrder: window.jsTranslations.tickerInOrder,
    tickerAmount: window.jsTranslations.tickerAmount,
    tickerInUSDT: window.jsTranslations.tickerInUSDT,
    tickerInBTC: window.jsTranslations.tickerInBTC,
    tickerRate: window.jsTranslations.tickerRate,

    graphCancelButtonShow: window.jsTranslations.graphCancelButtonShow,
    graphCancelButtonHide: window.jsTranslations.graphCancelButtonHide,
    graphOpenButtonShow: window.jsTranslations.graphOpenButtonShow,
    graphOpenButtonHide: window.jsTranslations.graphOpenButtonHide,
    graphFilterButtonOn: window.jsTranslations.graphFilterButtonOn,
    graphFilterButtonOff: window.jsTranslations.graphFilterButtonOff,

    tabsFilter: window.jsTranslations.tabsFilter,
    tabsGroup: window.jsTranslations.tabsGroup,
    tabsSort: window.jsTranslations.tabsSort,
    tabsCustomFields: window.jsTranslations.tabsCustomFields,

    customFieldsSave: window.jsTranslations.customFieldsSave,

    filterClearButton: window.jsTranslations.filterClearButton,
    filterSearchButton: window.jsTranslations.filterSearchButton
};
